export default "__VITE_ASSET__e8e04c76__"